import React from 'react';
import { useNavigate } from "react-router-dom";
import './Title.modules.css'; // スタイルを分離して管理

const Title = () => {
  const navigate = useNavigate();

  const handleStartGame = () => {
    navigate('/opening');
  };

  return (
    <div className="title-screen">
      {/* タイトルロゴ */}
      <img src="img/title_logo.png" alt="タイトル" className="title-logo" />

      {/* ボタン */}
      <button className="start-button" onClick={handleStartGame}>
        配信を見る
      </button>
    </div>
  );
};

export default Title;